import { useGetOCClaimStatus } from '../../screens/Claims/OverCharge/hooks';
import FormSelectBox from '../Inputs/FormSelectBox';

const OverChargeClaimStatusSelector = ({
  placeholder = 'Select Status',
  label = 'Status',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  disableValidation = false,
  mode = '',
}) => {
  const { data = [], isLoading } = useGetOCClaimStatus();
  const options = data.map((row) => ({
    label: row.claimStatusDescription,
    value: row.claimStatusCode,
  }));

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      mode={mode}
    />
  );
};

export default OverChargeClaimStatusSelector;
